import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types';
// import Notification from '../../Notification/Desktop/Notification';

// import History from '../../history';
import s from './DesktopHeader.css';
import logo from '../assets/logo.png';
import notif from '../assets/play.png';
import chevronDown from '../assets/chevron-down.png';
import iconsetting from '../assets/IconSettings.png';
import iconlogout from '../assets/logout.png';
import UserImage from '../assets/UserImage.png';
import settingIcon from '../assets/settingicon.png';
import featuredActive from '../assets/featuredActive.png';
import flyBall from '../assets/fly-ball.png';
import channelIcon from '../assets/channel_icon.png';
import vodIcon from '../assets/vod_icon.png';
import matchesIcon from '../assets/matches_icon.png';
import userIcon from '../assets/user_icon.png';
import videoActive from '../assets/videoActive.png';
import fb from '../assets/fb.png';
import tw from '../assets/tw.png';
import insta from '../assets/insta.png';
import appstore from '../assets/AppStore.png';
import gplay from '../assets/GooglePlay.png';
import youtube from '../assets/YoutubeIcon.png';
import { loop, otherMenu, sstvlogo } from '../../../global/assets/imageUrl';
import ssLogo from '@global/assets/images/sslogo.png';
// import chatLogo from '@global/assets/images/lvsp2.png';
import chatLogo from '@global/assets/images/chatWithUs.png';
import { getComponent } from '@supersoccer/gandalf';
const LazyLoad = getComponent('lazyload');

import _get from 'lodash/get';
import _kebabCase from 'lodash/kebabCase';

// let isNotifClosed = true;
class DesktopHeader extends Component {
  static propTypes = {
    page: PropTypes.string.isRequired
  };
  static propTypes = {
    user: PropTypes.objectOf(PropTypes.string).isRequired
  };

  state = {
    displayMenuOthers: false,
    displayMenuProfile: false,
    path: ''
  };

  componentDidMount() {
    const fullURL = window.location.href;
    let path = fullURL.replace(/^(?:\/\/|[^\/]+)*\//, '/');
    this.setState({ path: path });
  }

  showHideOthersDropdownMenu = (e, val) => {
    e.preventDefault();
    this.setState({
      displayMenuOthers: val
    });
  };

  showHideProfileDropdownMenu = (e, val) => {
    e.preventDefault();
    this.setState({
      displayMenuProfile: val
    });
  };

  handleLiveSupport = () => {
    window.open('/livesupport', '_blank');
  };

  render() {
    const assets = {
      logoUrl: ssLogo,
      searcIcon: loop,
      notifIcon: notif,
      settingIcon: iconsetting,
      logoutIcon: iconlogout,
      chevronDownIcon: chevronDown,
      UserImageimg: UserImage,
      settingIcon: settingIcon,
      featuredActive: featuredActive,
      flyBall: flyBall,
      videoActive: videoActive,
      channelIcon: channelIcon,
      vodIcon: vodIcon,
      matchesIcon: matchesIcon,
      userIcon: userIcon,
      otherMenu: otherMenu,
      fb: fb,
      tw: tw,
      insta: insta,
      appstore: appstore,
      gplay: gplay,
      youtube: youtube
    };

    let menu_headers = this.props.runtime.menu_headers;

    const {
      user: { sid, firstName, lastName },
      liveNotification: { isOpen }
    } = this.props;
    const { displayMenuOthers, displayMenuProfile } = this.state;
    let wrapperClass;
    // if (isNotifClosed) {
    //   wrapperClass = s.wrapperHeaderClose;
    // } else {
    //   // wrapperClass = isOpen ? s.wrapperHeaderOpen : s.wrapperHeaderClose;
    //   wrapperClass = s.wrapperHeaderClose;
    // }

    return (
      <Fragment>
        <div className={s.wrapperHeaderClose}>
          <div className={s.container_header}>
            {/* <Notification /> */}
            <div className={s.desk_globalHeader}>
              <div
                className={`${s.main_container} ${
                  displayMenuOthers || displayMenuProfile
                    ? s.main_container_height
                    : ''
                }`}
              >
                <div className={s.left_container}>
                  <a href="/" className={s.logo_container}>
                    <LazyLoad
                      containerClassName={s.img_wrapper}
                      src={assets.logoUrl}
                    />
                  </a>
                  <ul>
                    {menu_headers &&
                      menu_headers.map((menu, menu_index) => {
                        const menu_url = _get(menu, 'attributes.url', '');
                        let menu_text = _get(menu, 'attributes.title.id', null);

                        if (!menu_text) {
                          menu_text = _get(menu, 'attributes.title.en', '');
                        }

                        let isHome = false;
                        if (
                          _kebabCase(menu_text) === 'home' ||
                          _kebabCase(menu_text) === 'beranda'
                        ) {
                          isHome = true;
                        }

                        const relMenuUrl = isHome
                          ? '/'
                          : '/' + menu_url.replace(/^(?:\/\/|[^\/]+)*\//, '');

                        return (
                          <a
                            className={s.list_header}
                            href={menu_url}
                            key={menu_index}
                          >
                            {this.state.path !== relMenuUrl ? (
                              <li
                                className={
                                  this.state.path === relMenuUrl
                                    ? `${s.active}`
                                    : ''
                                }
                              >
                                {menu_text}
                              </li>
                            ) : (
                              <li
                                className={
                                  this.state.path === relMenuUrl
                                    ? `${s.active}`
                                    : ''
                                }
                              >
                                {menu_text}
                              </li>
                            )}
                          </a>
                        );
                      })}
                  </ul>
                </div>

                <div className={s.icon_container}>
                  <a href="https://www.facebook.com/TVSuperSoccer/">
                    <img alt="facebook icon" src={assets.fb} />
                  </a>
                  <a href="https://twitter.com/my_supersoccer">
                    <img alt="twitter icon" src={assets.tw} />
                  </a>
                  <a href="https://www.instagram.com/mysupersoccer/">
                    <img alt="instagram icon" src={assets.insta} />
                  </a>
                  <a href="https://www.youtube.com/channel/UCSM0oVXkkPrnvx902advygA/featured">
                    <img alt="Youtube icon" src={assets.youtube} />
                  </a>
                </div>
                <div className={s.chat_container} onClick={this.handleLiveSupport}>
                  <img src={chatLogo} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return { ...state };
};
// const defaultStyle = withStyles(s);
// export { GlobalHeader, defaultStyle };
// export default withStyles(s)(DesktopHeader);

export default compose(withStyles(s), connect(mapStateToProps))(DesktopHeader);
